import tables from './tables';
import utils from '../utils';

const getAllActiveBrands = async (token) => {
  try {
    const { data } = await utils.getFromMikMakFirebaseService(
      `get/${tables.brands}?orderBy=isActive&equalTo=true`,
      token,
    );
    const brands = data.reduce((brands, brand) => {
      brands[brand.brandId] = brand;

      return brands;
    }, {});

    return brands;
  } catch (e) {
    throw `Error requesting brands: ${e.message}`;
  }
};

const getBrandById = async (id, token) => {
  try {
    const { data: brand } = await utils.getFromMikMakFirebaseService(
      `getById/${tables.brands}/${id}`,
      token,
    );

    return brand;
  } catch (e) {
    throw `Error getting brand by id ${id}: ${e}`;
  }
};

const getAllActivePortfolios = async (token) => {
  try {
    const { data: portfolioData } = await utils.getFromMikMakFirebaseService(
      `get/${tables.portfolios}?orderBy=active&equalTo=true`,
      token,
    );

    return portfolioData;
  } catch (e) {
    throw `Error retrieving portfolios ${e.message}`;
  }
};

export default {
  getAllActiveBrands,
  getBrandById,
  getAllActivePortfolios,
};
